import { createFileRoute } from '@tanstack/react-router';

import { AdminTipsPage } from '@/components/admin/tips-page';
import { adminHead } from '@/lib/seo';
import { adminListTipsFn } from '@/server/functions/tips';

export const Route = createFileRoute('/_admin/admin/tips')({
    component: TipsRoute,
    head: () => adminHead('טיפים', '/admin/tips'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: () =>
        adminListTipsFn({ data: { status: 'unread', limit: 50 } }),
});

function TipsRoute() {
    const data = Route.useLoaderData();
    return <AdminTipsPage initial={data} />;
}
